interface LocalesDropdown {
  [key: string]: LocalesDropdownItem;
}

export interface LocalesDropdownItem {
  value: string;
  label: string;
}

export const languages = {
  nl: 31,
  en: -1,
  fr: -2,
  de: -3,
};
export type Language = keyof typeof languages;

export const languageToCode = (locale: keyof typeof languages) => {
  return languages[locale];
};

export const fetchTranslations = ({ language = "en" }) => {
  if (process.env.REACT_APP_USE_MOCK_TRANSLATIONS === "yes") {
    return import(`../mocks/locales/${language}`).then((module) => {
      return module.default;
    });
  } else {
    return import(`../../locales/${language}`).then((module) => {
      return module.default;
    });
  }
};


export const pimLocalesDropdown: LocalesDropdown = {
  "31": {
    value: "nl",
    label: "Nederlands",
  },
  "-1": {
    value: "en",
    label: "English",
  },
  "-2": {
    value: "fr",
    label: "Français",
  },
  "-3": {
    value: "de",
    label: "Deutsch",
  },
};

export const newShopLanguages: { [key: string]: string[] } = {
  BE: ["en", "fr", "nl"],
  CH: ["de", "fr"],
  DE: ["de"],
  FR: ["fr"],
  LU: ["de", "fr"],
  NL: ["nl", "en"],
};

export const oldShopLanguages: { [key: string]: string[] } = {
  BE: ["en", "fr", "nl", "de"],
  CH: ["de", "fr"],
  DE: ["de"],
  FR: ["fr"],
  LU: ["de", "fr"],
  NL: ["nl", "en", "de"],
};

export const isNewShop = (shopUrl?: string): boolean => {
  if (!shopUrl) return true;
  return shopUrl.includes("eriks.com");
};

export const getAvailableLanguagesByShop = (
  countryCode: string,
  isNew: boolean
): string[] => {
  const languageMap = isNew ? newShopLanguages : oldShopLanguages;
  return languageMap[countryCode] || [];
};
